import { forwardRef } from 'react';
import { Flex } from '../Flex/Flex';
import { Layout } from '../Layout/Layout';
import { Separator } from '../Separator/Separator';
import * as styles from './Phone.css';
import { PhoneTrigger } from './PhoneTrigger';
import type { PhoneTriggerProps } from './PhoneTrigger';

export interface PhoneTriggerWithSeparatorProps extends PhoneTriggerProps {
  readonly placeholder: string;
}

export const PhoneTriggerWithSeparator = forwardRef<HTMLButtonElement, PhoneTriggerWithSeparatorProps>(
  ({ placeholder, country, disabled, ...triggerProps }, ref) => (
    <Flex>
      <PhoneTrigger
        aria-label={`${placeholder}-country`}
        country={country}
        disabled={disabled}
        ref={ref}
        {...triggerProps}
      />
      <Layout as="div" className={styles.phoneInputContainerSeparator} tabIndex={-1}>
        <Separator
          className={styles.phoneInputSeparator}
          color={disabled ? '$borderDisabledSecondary' : '$borderEnabled'}
          decorative
          orientation="vertical"
          style={{
            height: '30px',
          }}
        />
      </Layout>
    </Flex>
  ),
);
